"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPhoneOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M22 16.82l-2.74 1.82a23.89 23.89 0 01-5.87-5.87L15.18 10l-3.74-6.2-7.57 2.52.13.85a27.26 27.26 0 007.5 13.33A27.26 27.26 0 0024.83 28l.85.15 2.52-7.57zm2.37 9a26.62 26.62 0 01-11.43-6.73A26.62 26.62 0 016.18 7.66l4.38-1.46 2.26 3.8L11 12.77l.37.56a25.86 25.86 0 007.35 7.35l.56.37L22 19.18l3.77 2.26z" })));
}
exports.default = SvgPhoneOutline;
//# sourceMappingURL=PhoneOutline.js.map